import React from 'react';
import PropTypes from 'prop-types';
import { Tab } from '@gasbuddy/react-components';
import styles from './styles.css';
import GlobalSiteTag from '../../../lib/global-site-tag';

export default function Tabs({ tabs, gTagTitle }) {
  const handleTabChange = (tabIndex) => {
    GlobalSiteTag.gTagEvent(gTagTitle, `${tabs[tabIndex].gTagTitle} Tab Clicked`);
  };

  return (
    <div className={styles.tabs}>
      <Tab
        renderActiveOnly
        panes={tabs.map(tabContent => ({ label: tabContent.label, content: tabContent.content }))}
        onTabChange={tabIndex => handleTabChange(tabIndex, tabs)}
      />
    </div>
  );
}

Tabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      content: PropTypes.any,
    }),
  ).isRequired,
  gTagTitle: PropTypes.string.isRequired,
};
